import {
  Configuration,
  FAIL_FETCH_CONFIGURATION,
  IFetchConfigurationPayload,
  FETCH_CONFIGURATION,
  SUCCESS_FETCH_CONFIGURATION,
} from '.'
import { ActionResponse } from '../../interfaces'

export const fetchConfiguration = (
  payload: IFetchConfigurationPayload
): ActionResponse<IFetchConfigurationPayload> => ({
  type: FETCH_CONFIGURATION,
  payload,
})

export const successFetchConfiguration = (payload: Configuration): ActionResponse<Configuration> => ({
  type: SUCCESS_FETCH_CONFIGURATION,
  payload,
})

export const failFetchConfiguration = (payload: string): ActionResponse<string> => ({
  type: FAIL_FETCH_CONFIGURATION,
  payload,
})
